import axios from "axios";
import { tempUrl } from "../contexts/ContextProvider";

export const handleLogout = async (dispatch, navigate) => {
  try {
    await axios.post(`${tempUrl}/auth/logout`, {}, { withCredentials: true });

    dispatch({ type: "LOGOUT" });
    navigate("/");
  } catch (err) {
    console.error("Logout failed:", err);
  }
};
